// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"1702":"4d34c113","7222":"18394c63","7937":"de4f6177"}[chunkId] || chunkId) + "." + {"1702":"f6d39d7fdea3b94d","5763":"0830eb930fd2a699","6893":"c15592ac62823f07","6974":"1df2360da494cc30","7222":"3afabda8737411ad","7937":"35aaedcf96e23598"}[chunkId] + ".js";
};